import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "./features/auth/pages/Login/Login";
import Unauthorized from "./common/pages/Unauthorized/Unauthorized";
import Layout from "./common/templates/Layout/Layout";
import RequireAuth from "./features/auth/components/RequireAuth/RequireAuth";
import PersistLogin from "./features/auth/components/PersistLogin/PersistLogin";
import Dashboard from "./features/dashboard/pages/Dashboard";
import AccountPage from "./features/users/pages/Account/Account";
import HandleChangePassword from "./features/users/pages/Account/Handlechangepassword";

import routes from "./routes/routes";

function App() {
  const router = createBrowserRouter([
    // Public routes without Layout
    { path: "/", element: <LoginPage /> },
    { path: "unauthorized", element: <Unauthorized /> },
    {
      element: <PersistLogin />,
      children: [
        {
          element: <RequireAuth />,
          children: [{ path: "*", element: <div></div> }],
        },
      ],
    },

    // Routes with Layout
    {
      element: <Layout />,
      children: [
        // Public routes with Layout
        { path: "change-password", element: <HandleChangePassword /> },
        { path: "account-settings", element: <AccountPage /> },
       
       


        // Protected routes
        {
          element: <PersistLogin />,
          children: [
            {
              element: <RequireAuth />,
              children: [
                ...routes,
                { path: "dashboard", element: <Dashboard /> },

              ],
            },
          ],
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
